import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Icon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EmptyListIcon = function EmptyListIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "68",
    height: "48",
    viewBox: "0 0 68 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    e2eid: "icons_index_svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M68 36.4919C68 42.8431 52.7777 47.9919 34 47.9919C15.2223 47.9919 0 42.8431 0 36.4919C0 31.5058 9.38162 27.2608 22.5 25.6663C26.0918 25.2297 30.4638 31.501 34.5 31.501C39.8849 31.501 38.8885 25.6761 44 25.6663C56.7129 25.6419 68 31.9619 68 36.4919Z",
      fill: "#E7E7E7",
      e2eid: "icons_index_path"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M51.1667 4.125L59.1875 22C59.4167 22.2292 59.4167 22.6875 59.4167 22.9167V34.375C59.4167 38.2708 56.4375 41.25 52.5417 41.25H15.875C11.9792 41.25 9 38.2708 9 34.375V22.9167C9 22.6875 9 22.2292 9.22917 22L17.25 4.125C18.1667 1.60417 20.6875 0 23.4375 0H44.9792C47.7292 0 50.25 1.60417 51.1667 4.125ZM23.4378 4.58301C22.5212 4.58301 21.6045 5.04134 21.3753 5.95801L14.7295 20.6247H25.042C25.7295 20.6247 26.417 21.083 27.1045 21.5413L31.0003 27.4997H37.6462L41.542 21.5413C42.0003 21.083 42.6878 20.6247 43.3753 20.6247H53.4587L47.042 5.95801C46.8128 5.04134 45.8962 4.58301 44.9795 4.58301H23.4378Z",
      fill: "#D1D4D9",
      e2eid: "icons_index_path_2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M51.9583 36.4583H15.2917C13.9167 36.4583 13 35.5417 13 34.1667V25H23.3125L27.2083 30.9583C27.6667 31.4167 28.3542 31.875 29.0417 31.875H38.2083C38.8958 31.875 39.5833 31.4167 40.0417 30.9583L43.9375 25H54.25V34.1667C54.25 35.5417 53.3333 36.4583 51.9583 36.4583Z",
      fill: "#E7E7E7",
      e2eid: "icons_index_path_3"
    })]
  });
};
/**
 * {@link https://tabler.io/icons/icon/calendar-clock Tabler Icons}
 */

export var CalendarTimeIcon = function CalendarTimeIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    e2eid: "icons_index_svg",
    children: [/*#__PURE__*/_jsx("path", {
      stroke: "none",
      d: "M0 0h24v24H0z",
      fill: "none",
      e2eid: "icons_index_path"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4",
      e2eid: "icons_index_path_6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0",
      e2eid: "icons_index_path_7"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15 3v4",
      e2eid: "icons_index_path_8"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7 3v4",
      e2eid: "icons_index_path_9"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3 11h16",
      e2eid: "icons_index_path_10"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18 16.496v1.504l1 1",
      e2eid: "icons_index_path_11"
    })]
  });
};
export var PdfIcon = function PdfIcon(props) {
  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), {}, {
    e2eid: "icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#F45B5B",
      d: "M38.333 10.783v27.55A1.666 1.666 0 0 1 36.667 40H3.332a1.667 1.667 0 0 1-1.667-1.667V1.667A1.667 1.667 0 0 1 3.333 0H27.55l10.783 10.783Z",
      e2eid: "icons_index_path"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F45B5B",
      d: "M38.333 10.783v27.55A1.666 1.666 0 0 1 36.667 40H3.332a1.667 1.667 0 0 1-1.667-1.667V1.667A1.667 1.667 0 0 1 3.333 0H27.55l10.783 10.783Z",
      e2eid: "icons_index_path_14"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FC8181",
      d: "M27.55 9.117V0l10.783 10.783h-9.116a1.667 1.667 0 0 1-1.667-1.666Z",
      e2eid: "icons_index_path_15"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M9.867 27.95H8.75a.416.416 0 0 1-.417-.45v-8.333a.417.417 0 0 1 .417-.417h2.433c2.495-.033 3.742.914 3.742 2.842-.067 1.8-1.13 2.75-3.192 2.85h-1.45V27.5a.418.418 0 0 1-.416.45Zm.416-7.692v2.6c.1 0 .3.017.6.05 1.325.134 1.975-.316 1.942-1.35 0-.9-.642-1.333-1.942-1.3a1.365 1.365 0 0 1-.6 0Zm6.025 7.242v-8.333a.417.417 0 0 1 .417-.417h2.725c3.067 0 4.608 1.583 4.65 4.642.042 3.058-1.583 4.591-4.65 4.591h-2.725a.416.416 0 0 1-.417-.483Zm1.942-7.275v6.15h1.05c1.833.067 2.733-.95 2.7-3.05-.033-2.1-.933-3.133-2.7-3.1h-1.05Zm9.008 7.725h-1.116a.417.417 0 0 1-.417-.417v-8.366a.417.417 0 0 1 .417-.417h5.108a.417.417 0 0 1 .417.417v.708a.417.417 0 0 1-.417.417h-3.575V22.5h3.333a.417.417 0 0 1 .417.417v.716a.417.417 0 0 1-.417.417h-3.333v3.45a.416.416 0 0 1-.417.45Z",
      e2eid: "icons_index_path_16"
    })]
  }));
};
export var LineChartIcon = function LineChartIcon(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), {}, {
    e2eid: "icons_index_Icon",
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M10 15.167a.64.64 0 0 1-.6-.467L6 4.633 4.6 8.767c-.067.2-.333.4-.6.4H1.333c-.4 0-.666-.267-.666-.667s.266-.667.666-.667h2.2L5.4 2.3a.64.64 0 0 1 .6-.467c.266 0 .533.2.6.467L10 12.367l1.4-4.134a.64.64 0 0 1 .6-.466h2.666c.4 0 .667.266.667.666s-.267.667-.667.667h-2.2L10.6 14.633c-.067.334-.333.534-.6.534Z",
      e2eid: "icons_index_path"
    })
  }));
};